import React from 'react';
import ReactDOM from 'react-dom/client';

// Third-party CSS: import BEFORE bootstrap so Bootstrap wins on conflicts
import 'rsuite/dist/rsuite-no-reset.min.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'react-toastify/dist/ReactToastify.min.css';

// Bootstrap AFTER third-party so its styles take precedence
import 'bootstrap/dist/css/bootstrap.min.css';

// App styles last (highest priority)
import './styles/portal.css';
import App from './App';

// FontAwesome library setup
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
library.add(fas, far);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
